import type { MinMaxRange } from './types'

export const DEFAULT_WEIGHT_RANGE: MinMaxRange = {
    min: 1.6,
    max: 5,
}

export function normalizeWeightRange(range: MinMaxRange | null): MinMaxRange {
    return {
        min: Math.min(range?.min ?? DEFAULT_WEIGHT_RANGE.min, DEFAULT_WEIGHT_RANGE.min),
        max: Math.max(range?.max ?? DEFAULT_WEIGHT_RANGE.max, DEFAULT_WEIGHT_RANGE.max),
    }
}
